import React from 'react'

const IconArrowOutlineDown = () => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g mask='url(#mask0_16865_420018)'>
        <path
          d='M10 12.774L5.28857 8.06253L6.06253 7.28857L10 11.2261L13.9375 7.28857L14.7115 8.06253L10 12.774Z'
          fill='#686867'
        />
      </g>
    </svg>
  )
}

export default IconArrowOutlineDown
